var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',_vm._g(_vm._b({},'a-select',_vm.attrs,false),_vm.listeners),[(_vm.$scopedSlots.options)?_vm._t("options",null,{"list":_vm.list}):_vm._l((_vm.list),function(d){return _c('a-select-option',{key:d.id},[(_vm.$scopedSlots.title)?_vm._t("title",null,{"option":d}):_c('span',[_vm._v(_vm._s(d[_vm.nameKey]))])],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }